export enum UserDeviceType {
    PersonalComputer = 0,
    Mobile
}